import Service from "../../AuthService";
const ScanEmployee = {
    getScanEmployee(page) {
        return Service.get("/scan_employee?page="+page);
    },
    showScanEmployee(id) {
        return Service.get("/scan_employee/" + id);
    },
    updateScanEmployee(id, data) {
        return Service.put("/scan_employee/" + id, data);
    },
    createScanEmployee(data) {
        return Service.post("/scan_employee", data);
    },
    deleteScanEmployee(id) {
        return Service.delete("/scan_employee/" + id);
    },
    searchScanEmployee(data){
        return Service.post("/scan_employee_search", data);
    },
    //import hour
    getImportOTHour(data){
        return Service.get(`/import_ot_hour?page=${data.page}&date=${data.date}&employee_id=${data.employee_id}`);
    },
    showImportOTHour(id){
        return Service.get(`/import_ot_hour/${id}`);
    },
    updateImportOTHour(id,data){
        console.log(`/import_ot_hour/${id}`,data);
        return Service.put(`/import_ot_hour/${id}`,data);
    },
    createImportOTHour(data){
        return Service.post(`/import_ot_hour`,data);
    },
    deleteImportOTHour(id){
        return Service.delete(`/import_ot_hour/${id}`);
    },
    printScanEmployeePDF(data) {
        return Service.get(`/work-time-pdf?name=${data.name}&employee_id=${data.employee_id}&department_id=${data.department_id}&start_date=${data.start_date}&end_date=${data.end_date}`
        )
    }
};
export default ScanEmployee;
